import { APP_BASE_HREF, NgOptimizedImage, provideImgixLoader } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ErrorHandler, NgModule, provideZoneChangeDetection } from '@angular/core';
import { BrowserModule, provideClientHydration } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CoreServicesModule, CoreSharedModule, CoreStoreModule } from '@app/core';
import { SpinModule } from '@app/services';
import { AppComponent } from './app.component';
import { ROUTES } from './app.routes';
import { ErrorHandlerUser } from './error';

@NgModule({
  declarations: [AppComponent],
  imports: [BrowserModule, BrowserAnimationsModule, NgOptimizedImage, ROUTES, SpinModule, CoreServicesModule, CoreSharedModule, CoreStoreModule],
  providers: [
    {
      provide: APP_BASE_HREF,
      useValue: '/',
    },
    {
      provide: ErrorHandler,
      useClass: ErrorHandlerUser,
    },
    provideClientHydration(),
    provideHttpClient(withInterceptorsFromDi()),
    provideImgixLoader('https://s3.sa-east-1.amazonaws.com/storage.shopclass.com.br'),
    provideZoneChangeDetection({ eventCoalescing: true }),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
